export default (state) => Object.values(state.apps.data)
